<lla-week-selector
  [singleSelection]="data.singleSelection"
  [includeFuture]="!!data.includeFuture"
  [selectedWeeks]="data.selectedWeeks"
  (canceld)="dialogRef.close()"
  (selectedWeeksChanged)="dialogRef.close($event)"
></lla-week-selector>
